import { Calendar03Icon, ChevronDownIcon, UploadIcon } from '@/icons';
import { Button, DatePicker, Select, Space } from 'antd';
import dayjs from 'dayjs';
import { useGetAllDepartmentsQuery } from '../../../../../../app/features/employee/emp-dashboard/emp-dashboard.api';
import { DB_DATE_FORMAT } from '../../../../../../constants/global.constants';
import { useQueryFilters } from '../../../../../../hooks/useQueryFilters';
import { useState } from 'react';
import BulkLeaveUpload from './BulkLeaveUpload';

const { RangePicker } = DatePicker;

export default function LeaveRequestFilter() {
  const [openUpload, setOpenUpload] = useState(false);
  const { filters, setFilterValue, setFilterValues } = useQueryFilters<any>();
  const { data: departmentsData } = useGetAllDepartmentsQuery({
    params: { status: 'active' },
  });

  // Set default to current date if no dates are selected
  // useEffect(() => {
  //   if (!filters.startDate && !filters.endDate) {
  //     const today = dayjs().format(DB_DATE_FORMAT);
  //     setFilterValues({
  //       startDate: today,
  //       endDate: today,
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <div className="flex flex-col gap-3 items-end">
      <Space className="filter-section" wrap>
        {/* <DatePicker
          size="large"
          placeholder="Select Date"
          className="w-40"
          suffixIcon={<Calendar03Icon size={16} />}
          value={dateValue}
          onChange={(value) => {
            if (value) {
              // Always format as date (YYYY-MM-DD)
              setFilterValue('date', value.format(DB_DATE_FORMAT));
            } else {
              setFilterValue('date', undefined);
            }
          }}
        /> */}
        {/* <Select
          size="large"
          className="w-36"
          placeholder="Branch"
          suffixIcon={<ChevronDownIcon size={24} />}
        /> */}

        <RangePicker
          size="large"
          placeholder={['Start Date', 'End Date']}
          className="w-80"
          suffixIcon={<Calendar03Icon size={16} />}
          value={
            filters.startDate && filters.endDate
              ? [
                  dayjs(filters.startDate, DB_DATE_FORMAT),
                  dayjs(filters.endDate, DB_DATE_FORMAT),
                ]
              : undefined
          }
          onChange={(dates) => {
            if (dates) {
              setFilterValues({
                startDate: dates[0]?.format(DB_DATE_FORMAT),
                endDate: dates[1]?.format(DB_DATE_FORMAT),
              });
            } else {
              setFilterValues({
                startDate: undefined,
                endDate: undefined,
              });
            }
          }}
          showToday={false}
        />

        <Select
          size="large"
          allowClear
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Status"
          value={filters?.status}
          options={[
            { label: 'Pending', value: 'pending' },
            { label: 'Approved', value: 'approved' },
            { label: 'Rejected', value: 'rejected' },
          ]}
          suffixIcon={<ChevronDownIcon className="text-white" size={24} />}
          onChange={(value) => setFilterValue('status', value)}
        />

        <Select
          size="large"
          allowClear
          style={{ width: 130 }}
          placement="bottomRight"
          placeholder="Department"
          styles={{ popup: { root: { width: 200 } } }}
          suffixIcon={<ChevronDownIcon className="text-white" size={24} />}
          onChange={(value) => setFilterValue('department', value)}
          options={
            departmentsData?.data?.data?.map((department) => ({
              value: department.id,
              label: department.name,
            })) || []
          }
        />
      </Space>
      <div>
        <Button
          size="large"
          className="btn-primary hover:!bg-teal-500 !text-neutral-700 hover:!text-neutral-700 !text-base !font-bold"
          onClick={() => setOpenUpload(true)}
        >
          Upload CSV
          <UploadIcon size={16} className="!font-semibold" />
        </Button>
      </div>
      <BulkLeaveUpload
        open={openUpload}
        handleClose={() => setOpenUpload(false)}
      />
    </div>
  );
}
